import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import './RDModal.scss';

const RDModal = ({
  title,
  isModalVisible,
  onPrimaryClick,
  onSecondaryClick,
  primaryText,
  secondaryText,
  children,
  isCloseIconVisible,
  modalWidth,
  cancelButtonStyle,
  modalStyle,
}) => (
  <Modal
    centered
    title={title}
    visible={isModalVisible}
    onOk={onPrimaryClick}
    onCancel={onSecondaryClick}
    okText={primaryText}
    cancelText={secondaryText}
    closable={isCloseIconVisible}
    width={modalWidth}
    cancelButtonProps={cancelButtonStyle}
    style={modalStyle}
  >
    {children}
  </Modal>
);

RDModal.defaultProps = {
  onPrimaryClick: () => {},
  onSecondaryClick: () => {},
  title: '',
  primaryText: '',
  secondaryText: '',
  isCloseIconVisible: false,
  modalWidth: 500,
  cancelButtonStyle: {},
  modalStyle: {},
};

RDModal.propTypes = {
  /** Modal title */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Whether the modal is visible or not */
  isModalVisible: PropTypes.bool.isRequired,
  /** Modal Content */
  children: PropTypes.element.isRequired,
  /** Specify a function that will be called when a user clicks the primary button */
  onPrimaryClick: PropTypes.func,
  /** Specify a function that will be called when a user clicks mask, close button on top right or secondary button */
  onSecondaryClick: PropTypes.func,
  /** Text of the primary button */
  primaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Text of the secondary button */
  secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Whether a close (x) button is visible on top right of the modal dialog or not */
  isCloseIconVisible: PropTypes.bool,
  /** Width of the modal dialog */
  modalWidth: PropTypes.number,
  /** The cancel button style.
   * This is useful when we want to display single button on the modal. We can hide the secondary button using display: none */
  cancelButtonStyle: PropTypes.shape({}),
  /** Inline modal style */
  modalStyle: PropTypes.shape({}),
};

export default RDModal;
